import { Row } from "antd";
import SearchCategories from "../SearchCategories";
import "./HomeBanner.scss";
import { NavLink } from "react-router-dom";
import { env } from "../../env/env";

export default function HomeBanner() {
  return ( 
    <Row>
      <div className={`home-banner dsab`}>
        <div className="mobile-search-cats">
          <SearchCategories />
        </div>

        <div className="dsa-banner">
          <div className="video-container">
            <video src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/DSAGeometricBanner.mp4" autoPlay loop muted playsInline/>
          </div>
          <div className="left-section">
            <div className="dsa-title">
              <img className="hero" src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/DSABannerHero.webp" alt="hero"/>
              <div>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/DSATeal.svg" alt="DSA icon"/>
                <h2>Display</h2>
              </div>
              <div className="separator"/>
              <h3>Goodbye, thumb drive!</h3>
            </div>
          </div>
          <div className="right-section">
            <a className="ant-btn ant-btn-lg" href="/feature/digital-menu-board-solution.html" target="_blank" rel="noreferrer">Learn More</a>
            <NavLink to={`${env.dashboardPath}/dsa/manage`} className="ant-btn ant-btn-lg try-out">Try It Out</NavLink>
          </div>
        </div>
      </div>
    </Row>
  );
}
